import { inject, Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, firstValueFrom, Observable } from 'rxjs';
import { TokenManagerService } from './token-manager.service';

export type AuthState = 'INITIALIZING' | 'NOT_LOGGED_IN' | 'LOGGED_IN';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  public state = signal<AuthState>('INITIALIZING');
  tokenManager = inject(TokenManagerService);
  private state$: Observable<AuthState>;

  constructor() {
    this.state$ = toObservable(this.state);
    this.tokenManager.stream().subscribe((token) => {
      if (token) {
        this.state.set('LOGGED_IN');
      } else {
        this.state.set('NOT_LOGGED_IN');
      }
    });
  }

  async isLoggedIn(): Promise<boolean> {
    const stateValue = await firstValueFrom(this.state$.pipe(filter((state) => state !== 'INITIALIZING')));
    return stateValue === 'LOGGED_IN';
  }

  async waitForLogin(): Promise<void> {
    await firstValueFrom(this.state$.pipe(filter((state) => state === 'LOGGED_IN')));
  }

  async getAccessToken() {
    return this.tokenManager.get();
  }
}
